import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@aize/authentication';
import { asapScheduler, delay, take } from 'rxjs';
import {
  StateLoaderTypes,
  StateLoaderComponent
} from '@shared/components/state-loader/state-loader.component';

@Component({
  selector: 'app-callback',
  template: '<app-state-loader [type]="StateLoaderTypes.Loading"></app-state-loader>',
  styleUrls: ['./callback.component.scss'],
  imports: [StateLoaderComponent]
})
export class CallbackComponent implements OnInit {
  readonly StateLoaderTypes = StateLoaderTypes;

  private readonly authService = inject(AuthenticationService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.authService.isAuthenticated$.pipe(take(1), delay(3000)).subscribe({
      next: (authenticated: boolean) => {
        if (authenticated) {
          asapScheduler.schedule(() => this.router.navigate(['elements']).then());
        } else {
          asapScheduler.schedule(() => this.router.navigate(['error']).then());
        }
      }
    });
  }
}
